import { ReactNode } from 'react';
import { yesOrNoOptions } from '~/components';

export const SelectedYesNoContent = ({
    option,
    YesContent,
    NoContent,
}: {
    option: string;
    YesContent: ReactNode;
    NoContent: ReactNode;
}) => {
    switch (option) {
        case yesOrNoOptions[0].value:
            return YesContent;
        case yesOrNoOptions[1].value:
            return NoContent;
        default:
            return null;
    }
};
